module.exports = __webpack_public_path__ + "assets/GivenAngleBisectorDetailed.b217cae7360ddb674f663de5d27fdd84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/GivenAngleBisectorDetailed.png
// module id = 516
// module chunks = 0